import React from 'react'
import DoctorProfile from '../../components/DoctorProfile/DoctorProfile'

function DoctorProfilePage() {
  return (
    <DoctorProfile/>
  )
}

export default DoctorProfilePage